/**
 * @fileoverview Job Detail Index Route
 *
 * Purpose: Redirects to the job's current phase when navigating to /dashboard/jobs/:jobId
 * URL: /dashboard/jobs/:jobId
 */

import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { convexQuery } from "@convex-dev/react-query";
import { api } from "@cvx/_generated/api";
import type { Id } from "@cvx/_generated/dataModel";
import { useEffect } from "react";
import { Loader2 } from "lucide-react";

export const Route = createFileRoute(
  "/_app/_auth/dashboard/_layout/jobs/$jobId/",
)({
  component: JobDetailIndex,
});

function JobDetailIndex() {
  const { jobId } = Route.useParams();
  const navigate = useNavigate();

  const { data: job } = useQuery(
    convexQuery(api.jobs.queries.getJob, { jobId: jobId as Id<"jobs"> }),
  );

  useEffect(() => {
    if (job) {
      navigate({
        to: `/dashboard/jobs/$jobId/${job.currentPhase}`,
        params: { jobId },
        replace: true,
      });
    }
  }, [job, jobId, navigate]);

  return (
    <div className="flex h-32 items-center justify-center">
      <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
    </div>
  );
}
